import { api } from '@/api'
import { Period } from '@/ui-kit'
import { useQuery, UseQueryResult } from '@tanstack/react-query'

export function useUserReferralPoints(period: Period): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    queryKey: ['useUserReferralPoints', period],
    queryFn: () => api.get(`/user/stats/referral-points?period=${period}`),
    retry: 0
  })
}

/**
 * `enabled` is threaded from the caller, as in `useBuzzBalance`: the route 404s where
 * Buzz is off, so a flag-off session must issue zero requests to it.
 */
export function useUserCallPoints(
  period: Period,
  options: { enabled: boolean }
): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    queryKey: ['useUserCallPoints', period],
    queryFn: () => api.get(`/user/stats/call-points?period=${period}`),
    enabled: options.enabled,
    retry: 0
  })
}
